import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { STATIC } from '../../lib/queryPresets';
import {
  getFeeAgreement,
  upsertFeeAgreement,
  setFeeAgreementProvision,
  type UpsertFeeAgreementInput,
} from '../../services/billing/feeAgreementService';

export const feeAgreementKeys = {
  all: ['fee_agreement'] as const,
  byDossier: (dossierId: string) => [...feeAgreementKeys.all, dossierId] as const,
};

export function useFeeAgreement(dossierId: string | undefined) {
  return useQuery({
    ...STATIC,
    queryKey: dossierId ? feeAgreementKeys.byDossier(dossierId) : ['fee_agreement', 'noop'],
    queryFn: () => getFeeAgreement(dossierId!),
    enabled: !!dossierId,
  });
}

export function useUpsertFeeAgreement() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpsertFeeAgreementInput) => upsertFeeAgreement(input),
    onSuccess: (row) => {
      qc.invalidateQueries({ queryKey: feeAgreementKeys.byDossier(row.dossier_id) });
    },
  });
}

export function useSetFeeAgreementProvision() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ dossierId, amount }: { dossierId: string; amount: number | null }) =>
      setFeeAgreementProvision(dossierId, amount),
    onSuccess: (_, { dossierId }) => {
      qc.invalidateQueries({ queryKey: feeAgreementKeys.byDossier(dossierId) });
    },
  });
}
